/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_AboutInputs */

const en_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const zh_hans1_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于我们`)
};

const pt_br2_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre`)
};

const es_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acerca de`)
};

const fr_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos`)
};

const de_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über uns`)
};

const ru_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О нас`)
};

const it_footer_about = /** @type {(inputs: Footer_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi siamo`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Footer_AboutInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_about = /** @type {((inputs?: Footer_AboutInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_AboutInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_about(inputs)
	if (locale === "pt-BR") return pt_br2_footer_about(inputs)
	if (locale === "es") return es_footer_about(inputs)
	if (locale === "fr") return fr_footer_about(inputs)
	if (locale === "de") return de_footer_about(inputs)
	if (locale === "ru") return ru_footer_about(inputs)
	if (locale === "it") return it_footer_about(inputs)
	return en_footer_about(inputs)
});